import React from 'react';
import { LocationDescriptor } from 'history';
import RequireProps from '../../../components/RequireProps';

const RequireMDN: React.FC<{ redirect: LocationDescriptor; mdn: string }> = (props) => (
  <RequireProps props={{ mdn: props.mdn }} redirect={props.redirect}>
    {props.children}
  </RequireProps>
);

export default RequireMDN;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/auth/components/RequireMDN.tsx